export default __webpack_public_path__ + "static/media/screen6.713db4e4.png";